import { Box, Button, Typography } from "@mui/material";
import React from "react";

export default function EmployerLetsStart() {
  return (
    <>
      <Box pt={10}>
        <Box sx={{ display: "flex", flexDirection:{md:'row', xs:'column'}, justifyContent: "space-between", py:3 }}>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: 600,
              fontSize: {md:"30px", xs:"20px"},
              lineHeight: "36px",
              color: "#000000",
            }}
          >
            Let’s Start
          </Typography>
        </Box>
        {/* <Box
          sx={{
            background:
              "linear-gradient(270deg, #F2F4FB 0%, #EFF2FA 25.93%, #E8EDF9 67.2%, #C8D8F1 100%)",
            borderRadius: "30px",
            height: '100%',
            textAlign: "start",
            justifyContent: "center",
            width: "100%",
            // display: "flex",
            p:5
          }}
        >
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: 500,
              fontSize: "20px",
              lineHeight: "24px",
              color: "#3665D0",
            }}
          >
            Let’s Start
          </Typography>
          <Box sx={{ width: "60%" }}>
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: 600,
                fontSize: "60px",
                lineHeight: "80px",
                color: "#202124",
              }}
            >
              Lorem Ipsum Dolor
              <span style={{ color: "#2544EE" }}>
                {" "}
                Dummy Simple Text Dolor Ipsum
              </span>{" "}
            </Typography>
            <Typography sx={{color:'#000', opacity: 0.5}}>
              Lorem ipsum dolor sit amet consectetur. Nulla mauris tempus
              convallis morbi amet turpis mauris laoreet. Odio porttitor lectus
              adipiscing leo enim amet.
            </Typography>
          </Box>
        </Box> */}

        <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="true">
  <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
  </div>
  <div class="carousel-inner">
    <div class="carousel-item active">
    <Box
          sx={{
            background:
              "linear-gradient(270deg, #F2F4FB 0%, #EFF2FA 25.93%, #E8EDF9 67.2%, #C8D8F1 100%)",
            borderRadius: "30px",
            height: '100%',
            textAlign: "start",
            justifyContent: "center",
            width: "100%",
            // display: "flex",
            p:5
          }}
        >
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: 500,
              fontSize: {md:"20px", xs:"15px"},
              lineHeight: "24px",
              color: "#3665D0",
            }}
          >
            Let’s Start
          </Typography>
          <Box sx={{ width:{md:"60%", xs:"100%"} }}>
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: 600,
                fontSize:  {md:"60px", xs:"30px"} ,
                lineHeight:{md:"80px", xs:"40px"},
                color: "#202124",
              }}
            >
              Lorem Ipsum Dolor
              <span style={{ color: "#2544EE" }}>
                {" "}
                Dummy Simple Text Dolor Ipsum
              </span>{" "}
            </Typography>
            <Typography sx={{color:'#000', opacity: 0.5}}>
              Lorem ipsum dolor sit amet consectetur. Nulla mauris tempus
              convallis morbi amet turpis mauris laoreet. Odio porttitor lectus
              adipiscing leo enim amet.
            </Typography>
          </Box>
        </Box>
    </div>
    <div class="carousel-item">
    <Box
          sx={{
            background:
              "linear-gradient(270deg, #F2F4FB 0%, #EFF2FA 25.93%, #E8EDF9 67.2%, #C8D8F1 100%)",
            borderRadius: "30px",
            height: '100%',
            textAlign: "start",
            justifyContent: "center",
            width: "100%",
            // display: "flex",
            p:5
          }}
        >
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: 500,
              fontSize: {md:"20px", xs:"15px"},
              lineHeight: "24px",
              color: "#3665D0",
            }}
          >
            Let’s Start
          </Typography>
          <Box sx={{ width:{md:"60%", xs:"100%"}}}>
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: 600,
                fontSize:  {md:"60px", xs:"30px"} ,
                lineHeight:{md:"80px", xs:"40px"},
                color: "#202124",
              }}
            >
              Lorem Ipsum Dolor
              <span style={{ color: "#2544EE" }}>
                {" "}
                Dummy Simple Text Dolor Ipsum
              </span>{" "}
            </Typography>
            <Typography sx={{color:'#000', opacity: 0.5}}>
              Lorem ipsum dolor sit amet consectetur. Nulla mauris tempus
              convallis morbi amet turpis mauris laoreet. Odio porttitor lectus
              adipiscing leo enim amet.
            </Typography>
          </Box>
        </Box>
    </div>
    <div class="carousel-item">
    <Box
          sx={{
            background:
              "linear-gradient(270deg, #F2F4FB 0%, #EFF2FA 25.93%, #E8EDF9 67.2%, #C8D8F1 100%)",
            borderRadius: "30px",
            height: '100%',
            textAlign: "start",
            justifyContent: "center",
            width: "100%",
            // display: "flex",
            p:5
          }}
        >
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: 500,
              fontSize: {md:"20px", xs:"15px"},
              lineHeight: "24px",
              color: "#3665D0",
            }}
          >
            Let’s Start
          </Typography>
          <Box sx={{ width: {md:"60%", xs:"100%"} }}>
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: 600,
                fontSize:  {md:"60px", xs:"30px"} ,
                lineHeight:{md:"80px", xs:"40px"},
                color: "#202124",
              }}
            >
              Lorem Ipsum Dolor
              <span style={{ color: "#2544EE" }}>
                {" "}
                Dummy Simple Text Dolor Ipsum
              </span>{" "}
            </Typography>
            <Typography sx={{color:'#000', opacity: 0.5}}>
              Lorem ipsum dolor sit amet consectetur. Nulla mauris tempus
              convallis morbi amet turpis mauris laoreet. Odio porttitor lectus
              adipiscing leo enim amet.
            </Typography>
          </Box>
        </Box>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>





      </Box>
    </>
  );
}
